import { object } from 'yup';

import { Enum, VOUCHER_VALIDATOR } from '@/common/utils';

export type CONTROL_LIST = Enum<typeof CONTROL_LIST>;
export const CONTROL_LIST = Enum('voucherId');

export type ControlListDefs = {
  [CONTROL_LIST.voucherId]: string;
};

export const VALIDATION_SCHEMA = object().shape({
  [CONTROL_LIST.voucherId]: VOUCHER_VALIDATOR,
});
